<template>
  <div class="cookieconsent">
    <cookie-law
      buttonText="J'accepte"
      buttonDecline="true"
      buttonDeclineText="Je refuse"
      message="Ce site internet utilise des cookies utiles à votre navigation"
      buttonLinkNewTab="true"
      buttonLink="#/pages/cookies"
      buttonLinkText="En savoir plus"
    >
      <!-- <div slot-scope="props">
            <button class="skew" @click="props.accept"><span>I accept</span></button>
            <p>
            This site uses 🍪
            </p>
            <button class="skew" @click="props.close"><span>Ignore me</span></button>
      </div>-->
    </cookie-law>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";

export default {
  Name: "CookieConsent",
  components: { CookieLaw }
};
</script>

<style>
.Cookie--base a.Cookie__button{
    background: transparent !important;
    color: #aaa;
    text-decoration: underline;
    font-style: italic;
}

.Cookie--base a.Cookie__button:hover{
    background: #cbcbcb !important;
    color: #fff;
}

.Cookie__buttons{
    margin-top: 0;
    margin-bottom: 0;
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: repeat(2, 1fr);
}

.Cookie__content{
    margin-top: 0;
    margin-bottom: 15px;
}

.Cookie__buttons > a{
    grid-row: 1;
    grid-column: 1 / 2;
}

.Cookie__buttons button.Cookie__button--decline{
    grid-row: 2;
    grid-column: 1;
}

.Cookie__buttons button.Cookie__button{
    grid-row: 2;
    grid-column: 2;
}

@media only screen and (min-width: 48rem){
    .Cookie__buttons{
        display: flex !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/template/CookieConsent.vue